export function BrandingIcon({ ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" {...props}>
      <g id="Group_24491" data-name="Group 24491" transform="translate(-865 -172)">
        <g
          id="Rectangle_10299"
          data-name="Rectangle 10299"
          transform="translate(865 172)"
          fill="#fff"
          stroke="currentColor"
          strokeWidth="1"
          opacity="0"
        >
          <rect width="24" height="24" stroke="none" />
          <rect x="0.5" y="0.5" width="23" height="23" fill="none" />
        </g>
        <path
          id="Path_50068"
          data-name="Path 50068"
          d="M899,4930.033l-6.75-6.773a5.864,5.864,0,0,0-.961-.866,2.979,2.979,0,0,0-.771-.322,5.856,5.856,0,0,0-1.285-.072h-3.566M883,4927.98v1.758a3.9,3.9,0,0,0,.049.866,1.849,1.849,0,0,0,.213.518,4.04,4.04,0,0,0,.571.642l6.933,6.962c.7.705,1.056,1.062,1.462,1.187a1.768,1.768,0,0,0,1.1,0c.406-.125.758-.481,1.462-1.187l2.2-2.214a4.479,4.479,0,0,0,1.188-1.463,1.81,1.81,0,0,0,0-1.107,4.48,4.48,0,0,0-1.188-1.464l-6.489-6.516a4.062,4.062,0,0,0-.64-.58,1.747,1.747,0,0,0-.515-.205,3.476,3.476,0,0,0-.856-.054h-2.644a4.374,4.374,0,0,0-1.874.2,1.8,1.8,0,0,0-.777.777A4.463,4.463,0,0,0,883,4927.98Z"
          transform="translate(-14 -4747)"
          fill="rgba(0,0,0,0)"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.6"
        />
      </g>
    </svg>
  );
}
